// extracted by mini-css-extract-plugin
export default {"label":"TokenLabel-module__label","chainLabel":"TokenLabel-module__chainLabel","rwaStockLabel":"TokenLabel-module__rwaStockLabel"};